<script lang="ts">
  import type { ToggleButtonOption } from '$shared/components/types';
  import { ToggleBackgroundColor, ToggleButtonSize } from './ToggleButtonProps';
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    disabled?: boolean;
    checked?: boolean;
    options: ToggleButtonOption;
    onclick?: (e: MouseEvent) => void;
    onchange?: (e: Event) => void;
  }

  let { disabled = false, checked = $bindable(false), options, onclick, onchange }: Props = $props();

  let iconValue = $derived(checked ? 'icon-check white' : 'icon-x white');
  let className = $derived(`${options?.size || ToggleButtonSize.Medium} ${
    options?.inactiveColor || ToggleBackgroundColor.Default
  }`);
</script>

<div class="comp-toggle-button" class:disabled>
  <label class="toggle-button {className}" class:checked for={options?.name}>
    <input
      id={options?.name}
      tabIndex={options?.tabIndex || -1}
      bind:checked
      type="checkbox"
      hidden
      {disabled}
      onclick={(e) => { e.stopPropagation(); onclick?.(e); }}
      {onchange}
    />
    <div data-cy="toggle-button" class="toggle-container">
      <div class="toggle-switch">{''}</div>
      <div class="toggle-icon"><Icon value={iconValue} fontSize={'14px'} size={'14px'} /></div>
    </div>
  </label>
</div>

<style src="./ToggleButton.css">
</style>
